<template>
	<div id="app">
		<p>hoasdfs this is home</p>
	</div>
</template>

<script>
export default {
	name: 'page',
	components: {
	}
}
</script>
<style>
</style>